(function () {
  'use strict';

  var STYLE_ID = 'sz-language-selector-styles';
  var MOBILE_SELECTOR_CLASS = 'mobile-menu__section--sz-language';

  function currentLocaleCode() {
    return (document.documentElement.lang || 'de').split('-')[0].toLowerCase();
  }

  function localeCode(locale) {
    return (locale || '').split('-')[0].toUpperCase();
  }

  function localeName(locale) {
    var code = (locale || '').split('-')[0].toLowerCase();
    if (code === 'de') return 'Deutsch';
    if (code === 'en') return 'English';
    if (code === 'fr') return 'Français';
    return localeCode(code);
  }

  function languageTitle() {
    var code = currentLocaleCode();
    if (code === 'en') return 'Language';
    if (code === 'fr') return 'Langue';
    return 'Sprache';
  }

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.header__action-item--locale .header__action-item-title{display:none!important;}',
      '.header__action-item--locale{border-left:0!important;align-self:center;min-width:auto!important;padding-left:10px!important;padding-right:10px!important;}',
      '.header__action-item--locale::before{display:none!important;}',
      '.header__action-item--locale .header__action-item-content{margin-top:0!important;}',
      '.header__action-item--locale .header__action-item-link{display:flex;align-items:center;gap:5px;font-weight:600;line-height:1.2;white-space:nowrap;}',
      '.header__action-item--locale .header__action-item-link svg{width:9px;height:9px;margin:0;}',
      '.header__action-item--locale button[name="locale_code"]{white-space:nowrap;}',
      '.mobile-menu__section--sz-language{padding-top:14px!important;padding-bottom:14px!important;}',
      '.mobile-menu__section--sz-language .mobile-menu__section-title{margin:0 0 8px!important;font-size:13px!important;line-height:1.3!important;font-weight:600!important;letter-spacing:.04em!important;text-transform:none!important;}',
      '.sz-mobile-language-list{display:inline-flex;align-items:stretch;gap:0;border:1px solid var(--border-color);border-radius:6px;overflow:hidden;background:#fff;}',
      '.sz-mobile-language-form{margin:0;}',
      '.sz-mobile-language-form+.sz-mobile-language-form{border-left:1px solid var(--border-color);}',
      '.sz-mobile-language-button{appearance:none;-webkit-appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;font:inherit;font-size:15px!important;font-weight:500;line-height:1;padding:0 14px;min-height:40px;min-width:72px;transition:background .2s ease,color .2s ease;}',
      '.sz-mobile-language-button.is-active{background:rgba(var(--accent-color-rgb),.08);color:var(--accent-color);font-weight:600;}',
      '.sz-mobile-language-button:focus-visible{outline:2px solid currentColor;outline-offset:-3px;}',
      'html[lang^="fr"] .section__header{gap:20px;}',
      'html[lang^="fr"] .section__header .section__title{min-width:0;line-height:1.25;}',
      'html[lang^="fr"] .section__action-link{flex:0 1 auto;max-width:45%;white-space:normal;text-align:right;line-height:1.25;font-size:16px;}',
      'html[lang^="fr"] .collection-list .collection-item__title{font-size:clamp(15px,1.15vw,18px)!important;line-height:1.35!important;text-align:center;white-space:normal;min-height:49px;display:flex;align-items:flex-start;justify-content:center;padding:0 6px;}',
      'html[lang^="fr"] .collection-list .collection-item__title svg{flex:0 0 auto;margin-top:4px;}',
      '@media screen and (max-width:739px){html[lang^="fr"] .section__header{align-items:flex-start;}html[lang^="fr"] .section__action-link{max-width:50%;font-size:14px;}html[lang^="fr"] .collection-list .collection-item__title{font-size:15px!important;min-height:42px;}}',
      '@media screen and (min-width:740px) and (max-width:999px){.header__action-item--locale.hidden-pocket{display:flex!important;}.header__action-item--locale{padding-left:8px!important;padding-right:8px!important;}}',
      '@media screen and (min-width:1000px){.mobile-menu__section--sz-language{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function compactHeaderLanguageSelector() {
    var item = document.querySelector('.header__action-item--locale');
    if (!item) return;

    var link = item.querySelector('.header__action-item-link');
    if (link) {
      var activeCode = localeCode(currentLocaleCode());
      var changed = false;

      Array.prototype.forEach.call(link.childNodes, function (node) {
        if (!changed && node.nodeType === 3 && node.nodeValue.trim()) {
          node.nodeValue = ' ' + activeCode + ' ';
          changed = true;
        }
      });

      if (!changed) {
        var textElement = link.querySelector('span:not(.visually-hidden)');
        if (textElement) textElement.textContent = activeCode;
      }

      link.setAttribute('aria-label', languageTitle() + ': ' + localeName(currentLocaleCode()));
    }

    Array.prototype.forEach.call(item.querySelectorAll('button[name="locale_code"]'), function (button) {
      var code = localeCode(button.value);
      button.textContent = code;
      button.setAttribute('aria-label', localeName(button.value));
      button.setAttribute('title', localeName(button.value));
    });
  }

  function buildMobileLanguageSelector() {
    var mobileMenu = document.getElementById('mobile-menu');
    var sourceForm = document.getElementById('localization_form_header_locale');

    if (!mobileMenu || !sourceForm) return;
    if (mobileMenu.querySelector('.' + MOBILE_SELECTOR_CLASS)) return;

    var languageButtons = sourceForm.querySelectorAll('button[name="locale_code"]');
    if (!languageButtons.length) return;

    var firstPanel = mobileMenu.querySelector('.mobile-menu__panel');
    var firstSection = firstPanel ? firstPanel.querySelector('.mobile-menu__section') : null;
    if (!firstPanel || !firstSection) return;

    var section = document.createElement('div');
    section.className = 'mobile-menu__section ' + MOBILE_SELECTOR_CLASS;

    var title = document.createElement('p');
    title.className = 'mobile-menu__section-title';
    title.textContent = languageTitle();
    section.appendChild(title);

    var list = document.createElement('div');
    list.className = 'sz-mobile-language-list';
    list.setAttribute('role', 'group');
    list.setAttribute('aria-label', languageTitle());

    Array.prototype.forEach.call(languageButtons, function (sourceButton, index) {
      var form = sourceForm.cloneNode(true);
      form.id = 'localization_form_mobile_locale_' + index;
      form.className = 'sz-mobile-language-form';

      Array.prototype.slice.call(form.children).forEach(function (child) {
        if (child.tagName !== 'INPUT') child.remove();
      });

      Array.prototype.slice.call(form.querySelectorAll('input[name="locale_code"]')).forEach(function (input) {
        input.remove();
      });

      var button = document.createElement('button');
      button.type = 'submit';
      button.name = 'locale_code';
      button.value = sourceButton.value;
      button.className = 'sz-mobile-language-button';
      button.textContent = localeName(sourceButton.value);

      if (sourceButton.getAttribute('aria-current') === 'true') {
        button.classList.add('is-active');
        button.setAttribute('aria-current', 'true');
      }

      form.appendChild(button);
      list.appendChild(form);
    });

    section.appendChild(list);
    firstPanel.insertBefore(section, firstSection);
  }

  function enhanceLanguageSelector() {
    installStyles();
    compactHeaderLanguageSelector();
    buildMobileLanguageSelector();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceLanguageSelector);
  } else {
    enhanceLanguageSelector();
  }

  document.addEventListener('shopify:section:load', enhanceLanguageSelector);
})();
